import Reveal from "./Reveal";
import CountUp from "./CountUp";
import { useI18n } from "../../lib/i18n";

function parseNumberOnly(raw) {
  const m = String(raw).match(/-?\d+(?:\.\d+)?/);
  return m ? m[0] : raw;
}

export default function StatsBar({ stats }) {
  const { cmsT } = useI18n();
  return (
    <section
      data-testid="stats-section"
      className="relative py-24 md:py-28 border-y border-line overflow-hidden"
      style={{ backgroundColor: "#111111" }}
    >
      {/* Flowing data streams */}
      <div className="data-streams">
        <div className="stream-2" />
        <div className="stream-3" />
      </div>
      {/* Subtle grid */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
           style={{
             backgroundImage:
               "linear-gradient(to right, rgba(255,255,255,1) 1px, transparent 1px)",
             backgroundSize: "120px 100%",
           }} />

      <div className="container-x relative z-10">
        <div className="grid sm:grid-cols-3 gap-12 md:gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.id} delay={i * 80}>
              <div
                data-testid={`stat-${s.id}`}
                className="relative pl-5 border-l-[3px] border-ember overflow-hidden"
              >
                {/* Watermark */}
                <span className="stat-watermark" aria-hidden="true">
                  {parseNumberOnly(s.number)}
                </span>

                <div className="relative font-display font-extrabold text-5xl md:text-6xl leading-none"
                     style={{ color: "#FFFFFF" }}>
                  <CountUp value={s.number} />
                </div>
                <div className="relative mt-3 font-light text-sm md:text-base max-w-[28ch]"
                     style={{ color: "#888888" }}>
                  {cmsT(s.suffix)}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
